import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import FrictionlessAddressForm from 'components/Addresses/FrictionlessAddressForm/FrictionlessAddressForm';
import { userSelector } from 'selectors/user/userSelector';
import orderUtils from 'utils/Order';
import EditDataActions from 'actions/EditDataActions';
import EditDataSelector from 'selectors/editData/editDataSelector';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;

const getText = getLocaleResourceFile('components/Addresses/AddressForm/locales', 'AddressForm');

const localization = createStructuredSelector({
    firstNameText: getTextFromResource(getText, 'firstName'),
    lastNameText: getTextFromResource(getText, 'lastName'),
    caName: getTextFromResource(getText, 'caName'),
    usName: getTextFromResource(getText, 'usName'),
    countryText: getTextFromResource(getText, 'country'),
    address2LabelText: getTextFromResource(getText, 'address2'),
    streetAddress: getTextFromResource(getText, 'address'),
    startTyping: getTextFromResource(getText, 'startTyping'),
    optional: getTextFromResource(getText, 'optional'),
    add: getTextFromResource(getText, 'add'),
    postalCode: getTextFromResource(getText, 'postalCode'),
    zipPostalCode: getTextFromResource(getText, 'zipPostalCode'),
    cityText: getTextFromResource(getText, 'city'),
    province: getTextFromResource(getText, 'province'),
    region: getTextFromResource(getText, 'region'),
    stateRegion: getTextFromResource(getText, 'stateRegion'),
    phone: getTextFromResource(getText, 'phoneNumber'),
    phoneContext: getTextFromResource(getText, 'phoneContext'),
    enterZipCodeText: getTextFromResource(getText, 'enterZipCodeText'),
    emailAddress: getTextFromResource(getText, 'emailAddress'),
    emailRequiredText: getTextFromResource(getText, 'emailRequiredText'),
    keepTyping: getTextFromResource(getText, 'keepTyping')
});

const fields = createSelector(
    (_ownState, ownProps) => ownProps,
    userSelector,
    EditDataSelector,
    localization,
    ({ isGuestCheckout, isGiftCardSection, editStore }, user, editData, locales) => {
        const isGiftCardOnlyOrder = orderUtils.isGiftCardOnly();

        const shouldShowEmailFieldInGiftCardSection = isGuestCheckout && isGiftCardOnlyOrder && isGiftCardSection;
        const shouldShowEmailFieldOutsideGiftCardSection = isGuestCheckout && !isGiftCardSection && !shouldShowEmailFieldInGiftCardSection;

        const shouldDisplayEmailInputField = shouldShowEmailFieldInGiftCardSection || shouldShowEmailFieldOutsideGiftCardSection;

        return {
            biAccount: user.beautyInsiderAccount,
            localization: locales,
            shouldDisplayEmailInputField,
            editStoreData: editData[editStore] || {}
        };
    }
);

const withComponentProps = wrapHOC(
    connect(fields, {
        updateEditData: EditDataActions.updateEditData,
        clearEditData: EditDataActions.clearEditData
    })
);

export default withComponentProps(FrictionlessAddressForm);
